export default {
    toaster: {
        border: "1px solid #959AAA",
        minWidth: "400px",
        borderRadius: "10px",
    },

    toastHeaderContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        
    },

    toastHeader: {
        fontSize: "16px",
        color: "#32325d",
        fontWeight: 600
    },

    closeIcon: {
        width: "24px",
        height: "24px",
    },

    toastBodyContainer: {
        padding: "14px 16px",
        borderTop: "0.5px solid #959AAA",
    },

    toastMessage: {
        margin: "0px",
        fontSize: "14px"
    },

    lightVariant: {
        backgroundColor: "white"
    },

    successVariant: {
        backgroundColor: "#90EE90"
    },

    warningVariant: {
        backgroundColor: "#FFFFE0"
    },

    dangerVariant: {
        backgroundColor: "#FFCCCB"
    },

    innerHtmlContent: {
        margin: "0px"
    }
}
